// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"708":"196f2440","2935":"fcf7545b","6155":"35d46e80","7371":"fcf7545b","8323":"196f2440","8986":"ea3db241"}[chunkId] + ".chunk.css";
};